module.exports = __webpack_public_path__ + "img/vite.59d25a74.png";